import React from "react";
import { useSelector } from "react-redux";
import SafetyDocumentsModal from "./SafetyDocumentsModal";
import { LAYOUT_TOPBAR_OFFSET, LAYOUT_CONTENT_GUTTER } from "@iso/constants/layout";

// Full-page Safety Documents browser, reached from the Safety nav section.
// Reuses the SafetyDocumentsModal browser in `asPage` mode (same categories →
// assets/forms → details/files flow), just without the modal chrome.
const SafetyDocumentsPage = () => {
  const activePropertyId = useSelector((state) => state.property.activePropertyId);

  // The private layout wraps page content in padding (90px top / 20px sides &
  // bottom) over a grey background. Cancel that padding so the page fills the
  // whole active area edge-to-edge, restoring only the top clearance below the
  // fixed topbar.
  return (
    <div
      style={{
        margin: `-${LAYOUT_TOPBAR_OFFSET}px -${LAYOUT_CONTENT_GUTTER}px -${LAYOUT_CONTENT_GUTTER}px`,
        paddingTop: LAYOUT_TOPBAR_OFFSET,
        background: "#fff",
        minHeight: "100vh",
      }}
    >
      <SafetyDocumentsModal asPage propertyId={activePropertyId} />
    </div>
  );
};

export default SafetyDocumentsPage;
